import { render } from "./TheB2bApp.vue?vue&type=template&id=88ed69d0&scoped=true&lang=pug"
import script from "./TheB2bApp.vue?vue&type=script&lang=js"
export * from "./TheB2bApp.vue?vue&type=script&lang=js"

import "./TheB2bApp.vue?vue&type=style&index=0&id=88ed69d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88ed69d0"]])

export default __exports__